module.exports = __webpack_public_path__ + "static/img/ppw.22e559d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ppw.png
// module id = M9EM
// module chunks = 0